import { Link, NavLink, useNavigate } from "react-router-dom";
import { Target, MoonStar, Sun, Menu, X } from "lucide-react";
import { useState } from "react";

export const Navbar = () => {
    const [open, setOpen] = useState(false);
    const navigate = useNavigate();

    const links = [
        { to: "/", label: "Home" },
        { to: "/common-number", label: "Common Number" },
        { to: "/dream-number", label: "Dream Number" },
        { to: "/hit-guti", label: "Direct Hit Guti" },
        { to: "/previous-results", label: "Previous Results" },
    ];

    return (
        <header className="sticky top-0 z-40 ticker-band text-white shadow-lg" data-testid="site-navbar">
            <div className="max-w-7xl mx-auto px-4 md:px-8 py-3 flex items-center justify-between gap-3">
                <Link to="/" className="flex items-center gap-2.5 group" data-testid="nav-home-logo">
                    <div className="h-9 w-9 rounded-xl bg-yellow-400 grid place-items-center text-blue-900 shadow-md">
                        <Target className="h-5 w-5" strokeWidth={2.5} />
                    </div>
                    <div className="leading-tight">
                        <div className="font-display font-bold text-base md:text-lg tracking-tight">
                            Morning &amp; Day &amp; Night
                        </div>
                        <div className="text-[10px] md:text-[11px] uppercase tracking-[0.16em] text-yellow-300/90">
                            All Result · Live Update
                        </div>
                    </div>
                </Link>

                <nav className="hidden lg:flex items-center gap-1">
                    {links.map(l => (
                        <NavLink
                            key={l.to}
                            to={l.to}
                            end={l.to === "/"}
                            data-testid={`nav-link-${l.to.replace(/\//g,'') || 'home'}`}
                            className={({ isActive }) =>
                                `px-3 py-1.5 rounded-full text-sm font-medium transition-colors ${
                                    isActive ? "bg-yellow-400 text-blue-950" : "text-blue-50 hover:bg-white/10"
                                }`
                            }
                        >
                            {l.label}
                        </NavLink>
                    ))}
                    <button
                        onClick={() => navigate("/admin/login")}
                        data-testid="nav-admin-btn"
                        className="ml-2 px-3 py-1.5 rounded-full text-sm font-semibold bg-white/10 border border-white/20 hover:bg-white/20 transition-colors"
                    >
                        Admin
                    </button>
                </nav>

                <button
                    className="lg:hidden inline-flex items-center justify-center h-10 w-10 rounded-lg bg-white/10 border border-white/20"
                    onClick={() => setOpen(v => !v)}
                    data-testid="nav-mobile-toggle"
                    aria-label="Menu"
                >
                    {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
                </button>
            </div>

            {open && (
                <div className="lg:hidden border-t border-white/10 bg-blue-950/95 backdrop-blur-xl px-4 py-3 space-y-1">
                    {links.map(l => (
                        <NavLink
                            key={l.to}
                            to={l.to}
                            end={l.to === "/"}
                            onClick={() => setOpen(false)}
                            data-testid={`mobile-nav-link-${l.to.replace(/\//g,'') || 'home'}`}
                            className={({ isActive }) =>
                                `block px-3 py-2 rounded-lg text-sm font-medium ${
                                    isActive ? "bg-yellow-400 text-blue-950" : "text-blue-50 hover:bg-white/10"
                                }`
                            }
                        >
                            {l.label}
                        </NavLink>
                    ))}
                    <button
                        onClick={() => { setOpen(false); navigate("/admin/login"); }}
                        data-testid="mobile-nav-admin-btn"
                        className="w-full text-left block px-3 py-2 rounded-lg text-sm font-semibold bg-white/10 border border-white/20"
                    >
                        Admin Login
                    </button>
                </div>
            )}
        </header>
    );
};
